<!---- Static Navbar start -->
<div class="header-bar">
  <div class="navbar navbar-custom">
  <a class="navbar-brand logomain mt-2" id="hidetxt"  ><img src="assets/images/logotxt.svg"
      height="33" class="logo ml-3 logotextClick"><img src="assets/images/logotxt.svg" width="150" class="logo1 sectpad logotextClick"></a>
  </div>
  <div class="col-12 text-center webview"> 
    <!-- <img src="assets/images/eva-icons.svg" class="signimg1 prescsimg" /> -->
  </div>
  </div>
  <!---- Static Navbar end -->
<main role="main" class="maincntq">
  <div class="getbannersect sectppad pb-2">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0 webview" [@flyInOut]="'in'">
        
        <div class="col-sm-12 p-0 mt-5">
          <h1 class="text-center ssnHeadTxt">It looks like further action is needed<br>
            so that you can sign up for this plan</h1>
          <div class="col-lg-7 col-md-8 m-auto">
            <div class="col-sm-8 offset-sm-2">
            <span class="ssnTxt d-inline-block mt-3 mb-3">We recognize that everyone needs energy, and while every energy provider has their own credit qualiﬁcation criteria, it doesn’t mean you will be left without any options.
            </span>
            <p class="ssnTxt mb-0">
                Please be sure to mention Honest Gorilla, when you speak with a {{providerContact != undefined && providerContact.provider_name?providerContact.provider_name:""}} representative.
              </p>
            <span class="ssnTxt d-inline-block mt-3">What would you like to do?</span>
          </div>
            <div class="col-sm-8 col-md-9 col-xl-5 m-auto text-left">
              <label class="custom-control custom-checkbox chkbox mb-2 box-shadow" for="Someonepleasehelpme">
                  <input type="checkbox" class="custom-control-input mgntp10" id="Someonepleasehelpme" value="Someone please help me" name="Someonepleasehelpme"
                      [(ngModel)]="ssndepostList.value4" (click)="onChangeRole($event)" />
                  <label class="custom-control-label font20" for="Someonepleasehelpme">Someone please help me</label>
              </label>
              <label class="custom-control custom-checkbox chkbox mb-2 box-shadow" for="willtryagainlater">
                  <input type="checkbox" class="custom-control-input mgntp10" id="willtryagainlater" value="Will try again later"
                      name="willtryagainlater" [(ngModel)]="ssndepostList.value5" (click)="onChangeRole($event)" />
                  <label class="custom-control-label font20" for="willtryagainlater">Will try again later</label>
              </label>
             </div>
           
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center">
            <button class="btn sectbtn mt-5" style="width:auto !important; padding-left:25px; font-size:18px; padding-right:25px;" [ngClass]="{'sectbtn': user_bot,'disabledButton':!user_bot}" [disabled]="isDisable" (click)="gotoHome()">THANK YOU</button>
          </div>
        </div>
      </div>
      <div class="row-fluid mobileview mt-0 pt-4">
          <div class="d-flex h-100 row pr-0">
              <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
                  <img style="width:100% !important;" src="assets/images/signimg.jpg" />
              </div>
              <div class="col-sm-9 col-9 px-0 my-auto">
                  <div class="arrow_box mr-3" [@flyOut]="'in'">
                      <h1 class="questionMob text-left">It looks like further action is needed so that you can sign up for this plan. What would you like to do?
                      </h1>
                  </div>
              </div>
          </div>  
          
          <div class="d-flex h-100 row pr-0 mt-4">
                
            <div class="col-sm-9 col-11 offset-col-1 px-0 m-auto">
                    <div class="col-12 px-0 mobileview">
                        <label class="custom-control custom-checkbox chkbox mb-2 box-shadow" for="findoutwhatsgoingon">
                            <input type="checkbox" class="custom-control-input mgntp10" id="findoutwhatsgoingon" value="Find out what’s going on" name="callnowtopostDeposit"
                                [(ngModel)]="ssndepostList.value6" (click)="onChangeRole($event)" />
                            <label class="custom-control-label font16" for="findoutwhatsgoingon">Find out what’s going on</label>
                        </label>
                        <label class="custom-control custom-checkbox chkbox mb-2 box-shadow" for="nothingwilltryagainlater">
                            <input type="checkbox" class="custom-control-input mgntp10" id="nothingwilltryagainlater" value="Nothing, will try again later" name="nothingwilltryagainlater"
                                [(ngModel)]="ssndepostList.value7" (click)="onChangeRole($event)" />
                            <label class="custom-control-label font16" for="nothingwilltryagainlater">Nothing, will try again later</label>
                      </label>
                    </div>
            </div>
        </div>

          <!-- <div class="col-sm-9 col-12 mt-4">
              <p class="semi-bold ssndeptxt mb-1 text-center">Deposit Required</p>
              <p class="ssnTxt">In order to complete signing up for this plan, you
                are kindly being asked to post a deposit. To find out
                the deposit amount and for further details, please
                contact:
              </p>
              <div class="ssnenergyTxt text-center">
                <p class="fntbold mb-0 mt-2">{{providerContact != undefined && providerContact.provider_name ? providerContact.provider_name :""}}</p>
                <p class="mb-1">{{providerContact != undefined && providerContact.working_hours?providerContact.working_hours:""}}</p>
                <p class="fntbold clrblue">{{providerContact != undefined && providerContact.customerDeposit_enquiry?providerContact.customerDeposit_enquiry:""}}</p>
              </div>
              <p class="ssnTxt">
                Please be sure to mention Honest Gorilla and {{selectedProduct.product_key}}
                when you speak with a {{providerContact != undefined && providerContact.provider_name?providerContact.provider_name:""}} representative.
              </p>
            </div> -->
            
              
           
             
            <div  class="col-sm-9 col-12 ml-auto px-0" id ="addf_id">
                <div style="width:100% !important; text-align: right;">
                    <div  class="mb-3 ash_box text-right" [@flyOutans]="'in'" *ngIf="isChecked && ansinSSncheck1">
                       
                       <h1 class="inline-block ansMob text-right" *ngIf="isChecked">{{ansinSSncheck1}}</h1>
                    </div>
                </div>
            </div>

            <div id = 'thankAns'>
            <div  class="d-flex h-100 row pr-0 mt-3" *ngIf="isChecked && (ansinSSncheck1 == 'Thank you, goodbye') && timeTrue == true">
                <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
                    <img style="width:100% !important;" src="assets/images/signimg.jpg" />
                </div> 
                <div class="col-sm-9 col-9 px-0 my-auto">
                    <div  class="arrow_box mr-3" [@flyOutans]="'in'" *ngIf="isChecked && (ansinSSncheck1 == 'Thank you, goodbye')">
                        <h1  class="questionMob">Got it, but before you leave, if you have any questions why your enrollment request did not go through and want to speak to someone about it, you may contact <span class="font-weight-bold p-1">{{selectedProduct.energy_provider}}</span>
                          <span class="mb-1">{{providerContact != undefined && providerContact.working_hours?providerContact.working_hours:""}} </span><br>
                          <span class="fntbold clrblue"><a [href]="'tel:' + providerContact.customerDeposit_enquiry" style="color:#1f0bcc !important ">{{providerContact != undefined && providerContact.customerDeposit_enquiry?providerContact.customerDeposit_enquiry:""}}.</a></span>
                         <span> Be sure to mention Honest Gorilla, when you speak with a {{providerContact.provider_name}} representative.</span></h1>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-12 px-0" id = 'thankAns1' *ngIf="isChecked && (ansinSSncheck1 == 'Thank you, goodbye') && timeTrue == true">
            <label class="custom-control custom-checkbox chkbox mb-2 pr-0 box-shadow" for="thankyou">
                <input type="checkbox" class="custom-control-input mgntp10" id="thankyou" value="Thank you" name="thankyou"
                    [(ngModel)]="ssndepostList.value8" (click)="onChangeRole($event)" />
                <label class="custom-control-label font20" for="thankyou">Thank you</label>
            </label>
            </div>
          </div>

          <div id = 'speaksomeone'>
            <div  class="d-flex h-100 row pr-0 mt-3" *ngIf="isChecked && (ansinSSncheck1 == 'I would like to speak with someone') && timeTrue == true">
                <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
                    <img style="width:100% !important;" src="assets/images/signimg.jpg" />
                </div> 
                <div class="col-sm-9 col-9 px-0 my-auto">
                    <div  class="arrow_box mr-3" [@flyOutans]="'in'" *ngIf="isChecked && (ansinSSncheck1 == 'I would like to speak with someone')">
                        <h1  class="questionMob">To learn more details why your enrollment request did not go through,  please contact  <span class="font-weight-bold pr-1">{{selectedProduct.energy_provider}}</span>
                          <span class="mb-1">{{providerContact != undefined && providerContact.working_hours?providerContact.working_hours:""}} </span><br>
                          <span class="fntbold clrblue"><a [href]="'tel:' + providerContact.customerDeposit_enquiry" style="cursor:pointer !important; color: #1f0bcc !important;">{{providerContact != undefined && providerContact.customerDeposit_enquiry?providerContact.customerDeposit_enquiry:""}}.</a></span><br>
                         <span> Be sure to mention Honest Gorilla, when you speak with a {{providerContact.provider_name}} representative.</span></h1>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-12 px-0" id = 'thankAns1' *ngIf="isChecked && (ansinSSncheck1 == 'I would like to speak with someone') && timeTrue == true">
            <label class="custom-control custom-checkbox chkbox mb-2 pr-0 box-shadow" for="thankyou">
                <input type="checkbox" class="custom-control-input mgntp10" id="thankyou" value="Thank you" name="thankyou"
                    [(ngModel)]="ssndepostList.value8" (click)="onChangeRole($event)" />
                <label class="custom-control-label font20" for="thankyou">Thank you</label>
            </label>
            </div>
          </div>


            <div  class="col-sm-9 col-9 ml-auto mt-4 px-0" >
                <div class="col-12"  style="width:100% !important; text-align: right;">
                    <div id ="secondAns_id"  class="mb-3 ash_box text-right" [@flyOutans]="'in'" *ngIf="ansinSSncheck2 == 'Goodbye'">
                        <h1  class="ansMob text-right">{{ansinSSncheck2}}</h1>
                    </div>
                </div>
            </div>
      </div>
    </div>
  </div>
</main>
<p class="m-0 text-muted tapmsg"  style="color:#0055FF !important;"><a href="javascript:void(0)" id='openModalButtonForAction' (click)="openModal(template)">
</a></p>


<ng-template #template>
  <div>
      <div class="modal-dialog" role="document">
      <div class="modal-content zind1 boxRadius">
          <div class="modal-body">
           <button type="button" class="close videoclose" id ="closeModelAlign" data-dismiss="modal" aria-label="Close" (click)="hideModal()">
              <div class="float-right mr-2" >
                  <img src="assets/images/editchart-close.svg" width="20">
              </div>
          </button>  
          
          <div class="service-modal px-sm-4">
            <div class="modal-border">
              <h1 class="text-left conthead font-weight-bold-calibre mt-4 pt-2 mb-2" style="font-size: 20px !important">Help is on the way </h1>
              <span style="clear: left;"></span>
            </div>
              <div class="bdy-section pt-0">
              <div>
              <p class="mt-2">You can contact 
                  <span class="font-weight-bold">{{selectedProduct.energy_provider}}</span> 
                  <span class="mb-1 px-1">{{providerContact != undefined && providerContact.working_hours?providerContact.working_hours:""}}</span>
                  <br><span class="fntbold clrblue"><a [href]="'tel:' + providerContact.customerDeposit_enquiry" style="color: #1f0bcc !important;">{{providerContact != undefined && providerContact.customerDeposit_enquiry?providerContact.customerDeposit_enquiry:""}}</a></span>  and please be sure to mention <strong> Honest Gorilla. </strong></p>
                   
                   <p class="mb-4">If you are receiving this message outside of business 
                     hours, then feel free to leave a Voicemail at the number provided above and someone will respond to you 
                     at their earliest convenience. </p>
                  
                  </div>   
              </div>
          </div>
          </div>
          </div>  
              </div>
          </div>
          
  </ng-template>